import store from '../../store/store';

export default function Item(opts={}){
    BaseConstructor.call(this)
    let {container,state} = opts
    let elements = {}
    let context = this

    this.generate = () =>{
        elements.container = this.createElement('div', 'item-wrapper')
        elements.item = this.createElement('div', 'item')

        $(elements.container).append(elements.item)
        $(container).append(elements.container)

        $(elements.container).on('click', _ =>{
             store.setOption('current_active', state.title)
        })
    }

    this.update = () =>{

    }

    this.setState = (state) =>{
        if(state === 'active'){
            $(elements.container).addClass('active')
        } else {
            $(elements.container).removeClass('active')
        }
    }

    init()

    function init(){
        store.subscribe('SET_OPTION', data=>{
            if(data.option === 'current_active'){
                context.setState(data.value === state.title ? 'active' : '')
            }
        })
    }
}

Item.prototype = Object.create(BaseConstructor.prototype)